import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddUser(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, surname: surname, email: email, password: password};
        fetch(`/api/user`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddUser'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setEmail('');
        setName('');
        setSurname('');
        setPassword('');
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Użytkownika"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddUser'>
                <TextField required autoFocus label='Email' value={email} onChange={(e) => setEmail(e.target.value || '')}/>
                <TextField required label='Imię' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField required label='Nazwisko' value={surname} onChange={(e) => setSurname(e.target.value || '')}/>
                <TextField required type="password" canRevealPassword revealPasswordAriaLabel="Pokaż Hasło" label='Hasło' value={password} onChange={(e) => setPassword(e.target.value || '')}/>
            </form>
        </Panel>
    )
}

export default AddUser;